import { scanStructure } from '../support';
import type { RepairContext, RepairProposal, RepairRule } from '../types';

/**
 * Insert the `:` between a property name and its value: `{"a" 1}` → `{"a": 1}`.
 *
 * The distinction between this and a missing comma cannot be made from the two tokens
 * alone — `"a" 1` inside an object is a missing colon, `"a" "b"` inside an array is a
 * missing comma — so the site comes from the container scan, which tracks what the grammar
 * is waiting for. The legacy pipeline had no rule for this at all.
 */
export const insertMissingColonRule: RepairRule = {
  id: 'insert-missing-colon',
  confidence: 'safe',
  priority: 26,
  resolves: ['syntax/colon-expected'],

  detect(ctx: RepairContext): readonly RepairProposal[] {
    return scanStructure(ctx.source, ctx.tokens).missingColon.map((site) => ({
      ruleId: 'insert-missing-colon',
      span: { from: site.after.to, to: site.before.from },
      edits: [{ from: site.after.to, to: site.after.to, insert: ':' }],
      labelCode: 'fix.insert-missing-colon',
      resolves: 'syntax/colon-expected',
    }));
  },
};
